import {Injectable} from '@angular/core';
import {DialogService} from '@shared/services/dialog-service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {PlatformCommand} from '@shared/commands/command-base';
import {take} from 'rxjs/operators';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {DialogModel} from '@shared/models/dialog.model';

@Injectable({
  providedIn: 'root',
})
export class ShowEditsCommandHandler implements IPlatformCommandHandler {
  constructor(
    private dialogService: DialogService,
    public snackBarService: SnackBarService,
    private platformQueryService: PlatformQueryService
  ) {

  }
  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {

    const fieldHeader = command.fieldValues['FieldHeader'];
    const title = fieldHeader ? `Update Histories (${fieldHeader})`: 'Update Histories';
    const parameters = {...command.fieldValues};
    parameters['Api'] = command.api;
    const dialogModel = DialogModel.create(title,
      'HistoricValueSelectorComponent', parameters, '1024px');
    this.dialogService.showOkCancelDialog(dialogModel)
      .pipe(take(1))
      .subscribe(state => {
        console.log(state);
        if (state.action === 'OK') {
          console.log(state);
          command.fieldValues['SelectedId'] = state.data.input['SelectedId'];
          handler.executeCommand(command);
        }
      });
    return true;
  }
}
